export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";